// Nội dung điều khoản từng tính năng (consent-to-terms).
// ⚠️ VERSION phải KHỚP với PolicyCatalog ở cab-user-service. Sửa nội dung → tăng version ở CẢ HAI.
// ⚠️ Đây là bản NHÁP để chạy cơ chế — cần pháp chế/luật sư rà trước khi coi là chính thức.

export interface PolicyDoc {
  key: string;
  version: string;
  title: string;
  /** Nội dung (mảng đoạn văn / gạch đầu dòng) — render trong modal. */
  body: string[];
}

export const POLICIES: Record<string, PolicyDoc> = {
  'ads-business': {
    key: 'ads-business',
    version: '1.1',
    title: 'Điều khoản Cab Ads Doanh nghiệp',
    body: [
      '1. Phạm vi: Điều khoản này áp dụng khi bạn đăng ký và sử dụng tài khoản quảng cáo doanh nghiệp trên Cab.vn để chạy quảng cáo.',
      '2. Tư cách & thông tin: Bạn cam kết là người đại diện hợp pháp của doanh nghiệp, đã định danh (eKYC), và mọi thông tin (tên doanh nghiệp, mã số thuế, giấy phép kinh doanh) là chính xác, trung thực. Nghiêm cấm mạo danh doanh nghiệp khác.',
      '3. Tiêu chuẩn nội dung quảng cáo: Bạn chịu trách nhiệm về nội dung và tuân thủ Luật Quảng cáo cùng pháp luật Việt Nam. NGHIÊM CẤM quảng cáo: hàng giả/hàng nhái/hàng cấm; thực phẩm chức năng thổi phồng công dụng như thuốc chữa bệnh; dịch vụ tài chính/cho vay/tiền ảo không được cấp phép; cờ bạc, cá độ; nội dung sai sự thật, kích động thù hằn, xâm phạm quyền riêng tư hoặc bản quyền của bên khác. Với sản phẩm cần giấy phép (dược, TPCN, tài chính…), phải cung cấp giấy phép hợp lệ.',
      '4. Kiểm duyệt: Cab có quyền xét duyệt, tạm dừng, TỪ CHỐI hoặc GỠ BỎ quảng cáo vi phạm bất cứ lúc nào mà KHÔNG CẦN báo trước; và tạm dừng quảng cáo bị người dùng báo cáo để rà soát.',
      '5. Thanh toán: Ngân sách quảng cáo nạp vào ví doanh nghiệp bằng chuyển khoản từ tài khoản ngân hàng ĐỨNG TÊN doanh nghiệp. Số dư ví dùng để chạy quảng cáo, KHÔNG rút ra tiền mặt.',
      '6. Hoàn ngân sách: (a) Khi chiến dịch bị TỪ CHỐI kiểm duyệt → phần ngân sách CHƯA phân phối được hoàn lại vào ví. (b) Khi bạn CHỦ ĐỘNG DỪNG chiến dịch giữa chừng → phần ngân sách CHƯA tiêu được hoàn lại vào ví. Phần đã phân phối (đã hiển thị/nhấp hợp lệ) KHÔNG được hoàn.',
      '7. Miễn trừ trách nhiệm về nội dung bên thứ ba: Cab.vn chỉ đóng vai trò HẠ TẦNG TRUNG GIAN cung cấp không gian hiển thị quảng cáo. Bạn (người chạy quảng cáo) hoàn toàn chịu trách nhiệm trước pháp luật về tính xác thực, chất lượng, hợp pháp của sản phẩm/dịch vụ và về bản quyền hình ảnh/nội dung sử dụng trong quảng cáo. Cab không bảo đảm và không chịu trách nhiệm cho giao dịch giữa bạn và người xem.',
      '8. Hóa đơn điện tử: Doanh nghiệp có nhu cầu xuất hóa đơn GTGT cho chi phí quảng cáo, vui lòng gửi yêu cầu kèm thông tin xuất hóa đơn (tên đơn vị, mã số thuế, địa chỉ, email nhận) trong vòng 7 ngày kể từ cuối tháng phát sinh chi tiêu. Cab phát hành hóa đơn điện tử theo đúng quy định pháp luật và gửi qua email đăng ký.',
      '9. Trách nhiệm: Bạn chịu trách nhiệm và bồi thường cho Cab đối với khiếu nại, thiệt hại phát sinh từ quảng cáo vi phạm của bạn.',
      '10. Dữ liệu: Cab xử lý dữ liệu theo chính sách bảo mật; thống kê hiệu suất mang tính ước tính.',
      '11. Sửa đổi: Cab có thể cập nhật điều khoản; khi có phiên bản mới, bạn cần đồng ý lại để tiếp tục sử dụng.',
    ],
  },

  'ads-personal': {
    key: 'ads-personal',
    version: '1.0',
    title: 'Điều khoản Quảng cáo / Đẩy bài (Cá nhân)',
    body: [
      '1. Phạm vi: Điều khoản này áp dụng khi bạn (cá nhân) dùng "Ca" để chạy quảng cáo hoặc Đẩy bài (Boost Post) trên Cab.vn.',
      '2. Thanh toán bằng Ca: Chạy quảng cáo/đẩy bài sẽ trừ "Ca" trong ví của bạn theo ngân sách bạn đặt. "Ca" đã dùng cho phần đã phân phối (hiển thị/nhấp hợp lệ) sẽ KHÔNG được hoàn.',
      '3. Tiêu chuẩn nội dung: Bạn chịu trách nhiệm về nội dung và tuân thủ pháp luật Việt Nam. NGHIÊM CẤM: hàng giả/hàng cấm, thực phẩm chức năng thổi phồng công dụng, dịch vụ tài chính/cho vay/tiền ảo không phép, cờ bạc/cá độ, nội dung sai sự thật, kích động thù hằn, xâm phạm quyền riêng tư hoặc bản quyền. Sản phẩm cần giấy phép phải hợp lệ.',
      '4. Kiểm duyệt: Cab có quyền từ chối, tạm dừng hoặc gỡ bỏ quảng cáo/bài được đẩy nếu phát hiện vi phạm tiêu chuẩn cộng đồng bất cứ lúc nào mà KHÔNG CẦN báo trước.',
      '5. Hoàn Ca: (a) Nếu bị TỪ CHỐI kiểm duyệt → phần "Ca" CHƯA phân phối được hoàn lại vào ví. (b) Nếu bạn CHỦ ĐỘNG DỪNG giữa chừng → phần "Ca" CHƯA tiêu được hoàn lại vào ví. Phần đã phân phối hợp lệ không được hoàn.',
      '6. Miễn trừ trách nhiệm: Cab.vn chỉ là hạ tầng trung gian cung cấp không gian hiển thị. Bạn hoàn toàn chịu trách nhiệm trước pháp luật về sản phẩm/dịch vụ bạn quảng cáo và về bản quyền hình ảnh/nội dung sử dụng.',
      '7. Sửa đổi: Cab có thể cập nhật điều khoản; khi có phiên bản mới, bạn cần đồng ý lại để tiếp tục sử dụng.',
    ],
  },

  'ekyc-data': {
    key: 'ekyc-data',
    version: '1.0',
    title: 'Điều khoản Định danh & Dữ liệu cá nhân (eKYC)',
    body: [
      '1. Đồng ý xử lý dữ liệu: Theo Nghị định 13/2023/NĐ-CP về bảo vệ dữ liệu cá nhân, bạn ĐỒNG Ý cho Cab.vn thu thập và xử lý dữ liệu định danh của bạn để xác thực danh tính (eKYC).',
      '2. Dữ liệu thu thập: Họ tên, số giấy tờ tuỳ thân (CCCD/CMND/hộ chiếu), hình ảnh giấy tờ và khuôn mặt dùng cho việc đối chiếu tại thời điểm xác thực.',
      '3. Mục đích: Xác minh danh tính người dùng cho các tính năng yêu cầu (creator, quyết toán thù lao/rút tiền, tài khoản quảng cáo doanh nghiệp), phòng chống gian lận và mạo danh.',
      '4. Bên xử lý: Việc đối chiếu do đối tác eKYC được cấp phép (VNPT/FPT.AI) thực hiện. Ảnh giấy tờ/khuôn mặt chỉ dùng trong quá trình đối chiếu và KHÔNG được Cab lưu trữ lại; Cab chỉ lưu họ tên và số giấy tờ (đã mã hoá) để phục vụ đối chiếu khi giao dịch.',
      '5. Thời gian lưu: Dữ liệu định danh được lưu trong thời gian bạn sử dụng dịch vụ và theo thời hạn luật định.',
      '6. Quyền của bạn: Bạn có quyền yêu cầu truy cập, chỉnh sửa, hoặc rút lại sự đồng ý; khi rút lại, các tính năng yêu cầu định danh sẽ ngừng khả dụng.',
      '7. Bảo mật: Cab áp dụng biện pháp kỹ thuật để bảo vệ dữ liệu của bạn.',
    ],
  },

  'wallet-topup': {
    key: 'wallet-topup',
    version: '1.0',
    title: 'Điều khoản Ví & Nạp tiền',
    body: [
      '1. Bản chất: "Ca"/điểm trong ví là ĐIỂM TIỆN ÍCH NỘI BỘ dùng trong hệ sinh thái Cab, KHÔNG phải tiền tệ, không phải phương tiện thanh toán và không có giá trị quy đổi ngoài Cab.',
      '2. Nạp: Số tiền nạp được quy đổi thành điểm theo tỉ lệ công bố. Giao dịch nạp là tự nguyện.',
      '3. Không hoàn tiền mặt: Điểm đã nạp dùng để chi tiêu trong Cab và KHÔNG được rút/hoàn thành tiền mặt (trừ khoản thù lao hợp lệ của creator theo quy định riêng).',
      '4. Phí: Có thể áp dụng phí nạp/xử lý theo biểu phí công bố tại thời điểm giao dịch.',
      '5. Chống rửa tiền & gian lận: Cab có quyền tạm giữ, rà soát hoặc từ chối giao dịch có dấu hiệu bất thường, gian lận hoặc vi phạm pháp luật.',
      '6. Trách nhiệm: Bạn chịu trách nhiệm về nguồn tiền hợp pháp và tính chính xác của thông tin thanh toán.',
    ],
  },

  'ads-credit': {
    key: 'ads-credit',
    version: '1.0',
    title: 'Điều khoản Tín dụng / Trả sau (Doanh nghiệp)',
    body: [
      '1. Bản chất: Hạn mức tín dụng là khoản Cab cho doanh nghiệp sử dụng trước để chạy quảng cáo; phần sử dụng vượt số dư là CÔNG NỢ mà doanh nghiệp có nghĩa vụ thanh toán.',
      '2. Sử dụng: Tín dụng chỉ dùng để chi cho quảng cáo trên Cab, không quy đổi ra tiền mặt.',
      '3. Thanh toán: Doanh nghiệp thanh toán công nợ bằng cách nạp tiền vào ví; khoản nạp sẽ bù trừ công nợ trước.',
      '4. Kỳ hạn & quá hạn: Công nợ phải được thanh toán theo kỳ hạn Cab thông báo. Khi quá hạn, Cab có quyền tạm dừng chạy quảng cáo, khoá tạo chiến dịch mới, và áp dụng biện pháp thu hồi theo quy định.',
      '5. Điều chỉnh hạn mức: Cab có quyền cấp, điều chỉnh hoặc thu hồi hạn mức tín dụng theo đánh giá rủi ro.',
      '6. Trách nhiệm: Người đại diện cam kết thanh toán đầy đủ công nợ phát sinh.',
    ],
  },

  cabplus: {
    key: 'cabplus',
    version: '1.0',
    title: 'Điều khoản Cab+ Pro',
    body: [
      '1. Dịch vụ: Cab+ Pro là gói hội viên trả trước mang lại các quyền lợi (trải nghiệm không quảng cáo, ưu đãi…) trong thời hạn đã mua.',
      '2. Thanh toán: Phí gói được trừ từ số dư điểm tại thời điểm mua/gia hạn.',
      '3. Không hoàn: Phí đã thanh toán không được hoàn lại khi bạn ngừng sử dụng giữa chừng.',
      '4. Gia hạn: Gói có thời hạn; hết hạn thì quyền lợi kết thúc trừ khi bạn gia hạn.',
      '5. Thay đổi: Cab có thể điều chỉnh quyền lợi/giá của gói và sẽ thông báo trước khi áp dụng.',
    ],
  },

  'creator-payout': {
    key: 'creator-payout',
    version: '1.0',
    title: 'Điều khoản Creator & Quyết toán thù lao',
    body: [
      '1. Điều kiện: Để trở thành Content Creator và nhận thù lao, bạn cần định danh (eKYC) và tuân thủ quy định nội dung của Cab.',
      '2. Thù lao: Thù lao phát sinh từ hoạt động hợp lệ trên Cab; các khoản không hợp lệ (gian lận, tự tương tác…) sẽ bị loại trừ.',
      '3. Thời gian giữ: Một số khoản có thể bị giữ theo thời hạn đối trả/rà soát trước khi được quyết toán.',
      '4. Nghĩa vụ thuế: Bạn tự chịu trách nhiệm về nghĩa vụ thuế thu nhập cá nhân theo quy định; Cab có thể khấu trừ/kê khai theo luật.',
      '5. Quyết toán: Yêu cầu quyết toán được xử lý qua tài khoản ngân hàng chính chủ khớp thông tin định danh của bạn.',
    ],
  },

  affiliate: {
    key: 'affiliate',
    version: '1.0',
    title: 'Điều khoản Tiếp thị liên kết (Affiliate)',
    body: [
      '1. Hoa hồng: Bạn nhận hoa hồng cho đơn hàng hợp lệ phát sinh qua liên kết của bạn.',
      '2. Giữ 30 ngày: Hoa hồng được GIỮ trong khoảng 30 ngày để trừ hao đổi/trả; chỉ được ghi nhận sau khi đơn hàng hoàn tất và hết thời gian đổi trả.',
      '3. Hủy/hoàn: Nếu đơn hàng bị hủy/hoàn, hoa hồng tương ứng bị hủy.',
      '4. Chống gian lận: Nghiêm cấm tự mua, spam, hoặc thao túng; vi phạm sẽ bị hủy hoa hồng và có thể khoá tính năng.',
      '5. Trách nhiệm: Bạn tuân thủ quy định quảng bá trung thực, không gây hiểu nhầm.',
    ],
  },
  publisher: {
    key: 'publisher',
    version: '1.0',
    title: 'Điều khoản Publisher (Cab Ads Network)',
    body: [
      '1. Nhúng quảng cáo: Bạn đặt mã ad-tag của Cab lên website mình sở hữu, chỉ trên (các) domain đã đăng ký và được xác minh.',
      '2. Doanh thu: Bạn nhận chia sẻ doanh thu theo impression/click HỢP LỆ; số liệu tính theo hệ thống đo lường của Cab.',
      '3. Chống gian lận: Nghiêm cấm tự click, dùng bot, iframe/quảng cáo ẩn, hoặc tạo lưu lượng giả; vi phạm sẽ bị hủy doanh thu và khoá tài khoản publisher.',
      '4. Nội dung: Website không vi phạm pháp luật, không chứa nội dung bị cấm; Cab có quyền từ chối hoặc ngừng hiển thị quảng cáo.',
      '5. Thanh toán & thuế: Chi trả theo chu kỳ Cab quy định; bạn tự chịu trách nhiệm nghĩa vụ thuế theo pháp luật.',
      '6. Chấm dứt: Cab có thể tạm ngừng hoặc chấm dứt hợp tác nếu bạn vi phạm điều khoản.',
    ],
  },

  donate: {
    key: 'donate',
    version: '1.0',
    title: 'Điều khoản Kênh Donate',
    body: [
      '1. Bản chất: Donate là hành động ủng hộ tự nguyện của người dùng dành cho creator/chiến dịch.',
      '2. Không hoàn: Khoản donate đã thực hiện là tự nguyện và KHÔNG được hoàn lại.',
      '3. Mục đích: Bạn cam kết dùng tính năng đúng mục đích, không lợi dụng để rửa tiền, lừa đảo hay gây quỹ trái phép.',
      '4. Quyền của Cab: Cab có quyền tạm dừng/rà soát kênh donate có dấu hiệu vi phạm hoặc bị báo cáo.',
    ],
  },

  // Bản nháp chờ sếp duyệt (spec 2026-10-10-brand-tax-compliance §3.2). Phiên bản khớp PolicyCatalog ở user-service.
  'brand-creator-tax': {
    key: 'brand-creator-tax',
    version: '1.0',
    title: 'Điều khoản thuế khi nhận tiền hợp tác',
    body: [
      '1. Thù lao, tiền thanh toán và tiền bồi thường bạn nhận qua sàn hợp tác là thu nhập của bạn.',
      '2. Bạn tự kê khai và nộp thuế thu nhập cá nhân cho khoản thu nhập này theo quy định của pháp luật Việt Nam.',
      '3. Cab.vn lưu đầy đủ dữ liệu các khoản tiền của bạn trên sàn và cung cấp cho cơ quan thuế khi được yêu cầu theo quy định.',
      '4. Nếu pháp luật yêu cầu Cab.vn khấu trừ thuế trước khi trả tiền, Cab.vn sẽ thông báo trước và cập nhật điều khoản này; bạn sẽ được đề nghị đồng ý lại.',
    ],
  },
};
